<template>
    <NavAndBody>
        <UserEdit/>
    </NavAndBody>
</template>

<script>
    import NavAndBody from '@/components/layout/NavAndBody';
    import UserEdit from '@/components/user/UserEdit';

    export default {
        name: 'UserEditView',
        components: {UserEdit, NavAndBody},
    };
</script>

<style lang="scss" scoped>
</style>